import React from 'react'
import PropTypes from 'prop-types'
import './spinner.scss'
import { SpinnerIcon } from 'assets'

export const Spinner = ({
    size = '200',
    pageSpinner = false,
    fullscreen = false,
    loadingMessage = '',
    ...props
}) => {
    const pageSpin = pageSpinner ? 'page-spinner' : ''
    const coverFullScreen = fullscreen ? 'page-spin-fullscreen' : ''
    return (
        <div
            className={[pageSpin, coverFullScreen].join(' ').trim()}
            data-testid="spinner"
            aria-label="loading"
            {...props}
        >
            <SpinnerIcon size={size} />
            {loadingMessage && (
                <p className="partial-loader--text">{loadingMessage}</p>
            )}
        </div>
    )
}

Spinner.propTypes = {
    size: PropTypes.string,
    pageSpinner: PropTypes.bool,
    fullscreen: PropTypes.bool,
    loadingMessage: PropTypes.string
}
